import React from "react";

import { yieldToMain } from "shared/lib/utils";

import { BookmarkAction } from "./enums";
import { StyledBookmarkIconOff, StyledBookmarkIconOn, StyledButton } from "./styles";

export type Props = {
  className?: string;
  isBookmarked: boolean;
  onClick?: (
    action: BookmarkAction,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
};

export const BookmarkButton: React.FunctionComponent<Props> = ({
  className,
  isBookmarked,
  onClick,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    void (async () => {
      await yieldToMain({ priority: "user-blocking" });
      onClick?.(isBookmarked ? BookmarkAction.UnBookmark : BookmarkAction.Bookmark, event);
    })();
  };

  return (
    <StyledButton
      aria-label={isBookmarked ? "unbookmark" : "bookmark"}
      className={className}
      onClick={handleClick}
    >
      {isBookmarked ? <StyledBookmarkIconOn /> : <StyledBookmarkIconOff />}
    </StyledButton>
  );
};

BookmarkButton.displayName = "BookmarkButton";
